import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';


function OurWorkPartnering() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={"solutionsLearnStyle"} maxWidth={false} component="section">
        <Container className={"solutionsLearnStyleInner"} maxWidth={false} component="section">
          <Grid className={globalClasses.containerSmall} container >
            <Grid className={globalClasses.containerInner} item xs={12} md={12}  >
              <Typography align="center"  variant="h3">With a robust skill set, collaborative team structure, and flexible project frameworks, we are prepared to tackle any challenge.  </Typography>
              <Button to='/work' variant="outlined" color="inherit"  className={'secondaryButton centerbtn'} align="center" component={RouterLink}>Learn more about our work</Button>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </ThemeProvider>
  );
};

export default OurWorkPartnering;